export default "__VITE_ASSET__dd85772a__"